import { useEffect, useState } from "react";
import { GetEmployeeList } from "../../api/request/license";
import SkeletonTable from "../../components/table/SkeletonTable";
import employeeListColumns from "../../columns/License/EmployeeListColumns";
import UserAvatar from "../../components/common/UserAvatar";
import ModalComponent from "../../components/global/modals/ModalComponent";

const AdminWiseEmployeeModal = ({ isOpen, setIsOpen, selectedAdmin }) => {
  const [data, setData] = useState([]);
  const [isLoadingLicense, setIsLoadingLicense] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  const AdminId = selectedAdmin?.id;
  const fetchData = async (searchText = "") => {
    if (selectedAdmin == null) return;
    try {
      setIsLoadingLicense(true);

      const { data } = await GetEmployeeList({
        admin_id: AdminId,
        search: searchText,
        page: currentPage,
      });

      setData(
        data?.data?.map((item) => ({
          ...item,
          status: (
            <p
              className={`${
                item?.status == "active" ? "text-green-500" : "text-red-500"
              } capitalize font-bold`}
            >
              {item?.status}
            </p>
          ),
          role: <p className="capitalize">{item?.role}</p>,
          name: <UserAvatar data={item} />,
        }))
      );

      setTotal(data?.total_record);
    } catch (error) {
      console.error("Error fetching employee list:", error);
    } finally {
      setIsLoadingLicense(false);
    }
  };

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination?.current);
  };

  useEffect(() => {
    if (AdminId) fetchData();
  }, [AdminId, currentPage]);

  return (
    <>
      <ModalComponent
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Employee List"
        width="1000px"
      >
        {selectedAdmin && (
          <div className="p-4 mb-4 rounded-lg  bg-white border ">
            <div className="text-lg font-semibold mb-2">
              <h2 className="font-semibold text-xl mb-3">Admin Details : </h2>
            </div>
            <div className="mr-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-1">
              <div>
                <span className="font-bold">Name: </span>
                {selectedAdmin?.name || "--"}
              </div>
              <div>
                <span className="font-bold">Email: </span>
                {selectedAdmin?.email || "--"}
              </div>
              <div>
                <span className="font-bold">Mobile No: </span>
                {selectedAdmin?.mobile_no || "--"}
              </div>
              <div>
                <span className="font-bold">License Name: </span>
                {selectedAdmin?.license?.license_name || "--"}
              </div>
            </div>
          </div>
        )}

        <div className="border bg-white rounded-xl py-3">
          <SkeletonTable
            columns={employeeListColumns}
            data={data}
            isLoading={isLoadingLicense}
            pagination={{
              current: currentPage,
              total: total,
              pageSize: 3,
              showSizeChanger: false,
            }}
            handleTableChange={handleTableChange}
          />
        </div>
      </ModalComponent>
    </>
  );
};

export default AdminWiseEmployeeModal;
